import React, { useState, useContext, useEffect } from 'react';
import { WebsiteContext } from '../../../context/WebsiteProvider';
import History from '../../../components/display/History';

const QuickHistory = () => {
  const { activity } = useContext(WebsiteContext);
  const [searchTerm] = useState('');
  const [selectedName] = useState('');
  const [filteredEvents, setFilteredEvents] = useState([]);

  const transformedData = activity.map((entry, index) => ({
    id: index,
    name: entry.user.username,
    action: entry.changes.map((change) => change.path.join(' -> ')).join(', '),
    type: entry.changes[0]?.type || 'Default',
    date: entry.date,
    description: entry.description,
  }));

  useEffect(() => {
    const filtered = transformedData.filter(
      (event) =>
        event.description.toLowerCase().includes(searchTerm.toLowerCase()) &&
        (selectedName === '' || event.name === selectedName)
    );
    setFilteredEvents(filtered);
  }, [searchTerm, selectedName, transformedData]);

  return (
    <div className="bg-white text-white dark:bg-stone-800">
      <div className="mb-2 flex"></div>
      <div className="mt-0.5">
        <History events={filteredEvents} />
      </div>
    </div>
  );
};

export default QuickHistory;
